module.exports = __webpack_public_path__ + "img/logo.1da00f04.svg";